import { useRef, useState } from "react";
import logoSmallWhite from "../../assets/images/logoSmallWhite.png";
import "./index.scss";
import { Link } from "react-router-dom";
const Navigation = () => {
  const menuToggle = useRef();
  const [toggleActive, settoggleActive] = useState("");

  // const HandleToggle = () => {
  //   // alert("Toogle Clicked");
  //   if (menuToggle.current.classList.contains("active")) {
  //     // alert("Toogle Active");
  //     menuToggle.current.classList.remove("active");
  //     settoggleActive("");
  //   } else {
  //     // alert("Toogle Not Active");
  //     menuToggle.current.classList.add("active");
  //     settoggleActive("active");
  //   }
  // };

  const HandleToggle = () => {
    // alert("Toogle Clicked");
    if (toggleActive === "active") {
      // alert("Toogle Active");
      settoggleActive("");
    } else {
      // alert("Toogle Not Active");
      settoggleActive("active");
    }
  };
  return (
    <>
      <header className="section-navigation">
        <nav>
          <ul className="menu">
            <li className="logo">
              <a href="/home">
                <img src={logoSmallWhite} alt="NYM-white-logo" />
              </a>
              {/* <Link to="#">MygradeCard</Link> */}
            </li>
            <li className={toggleActive + " item"}>
              <Link to="#" className="link">
                Home
              </Link>
            </li>
            <li className={toggleActive + " item"}>
              <Link to="#" className="link">
                About
              </Link>
            </li>
            <li className={toggleActive + " item"}>
              <Link to="#" className="link">
                Service
              </Link>
            </li>
            <li className={toggleActive + " item button"}>
              <a href="https://accounts.mygradecard.online/">Login</a>
            </li>
            <li className={toggleActive + " item button secondary"}>
              <Link to="#">Sign Up</Link>
            </li>
            <li ref={menuToggle} onClick={HandleToggle} className="toggle">
              <span className="bars"></span>
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
};

export default Navigation;
